import { Box, Button, FormControl, Input, InputLabel } from "@mui/material";
import Navbar from "../../../../posnavbar/Navbar";
import "./index.css";
import { useState } from "react";
import * as React from "react";
import Modal from "@mui/material/Modal";
import { useContext } from "react";
import { UserContext } from "App";
import {
  editUserDetails,
  getLocDetailByLongAndLat,
  getPosUserRole,
  logoutSession,
  userIdVerification,
  getUserRolesByFilter,
  getUserRolesById,
  fetchOrganisations,
} from "../../../../../../config/Services";
import { useNavigate } from "react-router-dom";
import { resetPin, updatePin } from "../../../../../../config/Services";
import { stopNotificationPolling } from "../../../../../../utils/notificationSystem/orderNotificationPollingService";
import OtpInput from "react-otp-input";
import { useEffect } from "react";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  BeakerIcon,
  BuildingOffice2Icon,
  CalendarIcon,
  CheckBadgeIcon,
  CheckIcon,
  ClockIcon,
  DeviceTabletIcon,
  EnvelopeIcon,
  FlagIcon,
  MapPinIcon,
  PencilSquareIcon,
  PhoneIcon,
  XMarkIcon,
  BellIcon,
  ShieldCheckIcon,
  BellSlashIcon,
} from "@heroicons/react/24/outline";
import { LuLogOut } from "react-icons/lu";
import { UserIcon } from "@heroicons/react/24/outline";
import { KeyIcon } from "@heroicons/react/24/outline";
import { BellAlertIcon } from "@heroicons/react/24/outline";
import CustomToggleButton from "../../../../../../customComponents/CustomToggleButton/CustomToggleButton";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { useLocation } from "react-router-dom";
import { ArrowLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import Switch from "../ProfileSettingsCard/Switch";

// this is the wrapper for the different modules
const ContainerWrapper = ({
  requiredHeader = true,
  wrapperRequired = true,
  containerHeadderIcon = <></>,
  containerHeadderTitle = "",
  rightSideContent = "",
  displayRightSideContent = false,
  children,
}) => {
  return (
    <section className={wrapperRequired ? "containerWrapperSection" : "containerSection"}>
      {requiredHeader && (
        <div className="containerWrapper-headder-div">
          <div className="containerWrapper-content-div">
            {/* left content */}
            <section className="containerWrapper-left-content">
              <p className="containerWrapper-icon">{containerHeadderIcon}</p>

              <p className="containerWrapper-left-content-p">{containerHeadderTitle}</p>
            </section>

            {/* right content */}
            {displayRightSideContent && (
              <section className="containerWrapper-right-content">
                <p className="containerWrapper-right-content-p">{rightSideContent}</p>
              </section>
            )}
          </div>
        </div>
      )}

      {children}
    </section>
  );
};

const Cards = ({ header = "N/A", description = "N/A", value = "N/A" }) => {
  return (
    <div className="personal-details-cards">
      <p className="personal-details-cards-header">{header}</p>
      <p className="personal-details-cards-value">{value}</p>
      <p className="personal-details-cards-description">{description}</p>
    </div>
  );
};

// organization - information section
const OrganizationInfo = ({
  profilePic,
  orgName,
  locName,
  branchType,
  orgId,
  locId,
  branchSubType,
}) => {
  const organizationDeailsLeftSectionData = [
    {
      id: "organization_name",
      label: "Organization Name",
      value: orgName,
    },
    {
      id: "location_name",
      label: "Location Name",
      value: locName,
    },
    {
      id: "branch_type",
      label: "Branch Type",
      value: branchType,
    },
  ];

  const organizationDetailsRightSectionData = [
    {
      id: "organization_id",
      label: "Organisation Id",
      value: orgId,
    },
    {
      id: "location_id",
      label: "Location Id",
      value: locId,
    },
    {
      id: "sub_branch_type",
      label: "Sub Branch Type",
      value: branchSubType,
    },
  ];

  return (
    <section className="organization-name-container-section">
      <Box className="image-container-box">
        <img className="user-profile-image-box" src={profilePic} alt="err" />
      </Box>

      <div className="organization-details-container">
        {/* left section */}
        <section className="orgdetails-left-section-data">
          {organizationDeailsLeftSectionData?.map((el, idx) => {
            return (
              <div className="orgdetails-left-div-data-row" key={el?.id ?? idx}>
                <p className="orgDetails-p-label">{el?.label ?? "-"}</p>
                <p className="orgDetails-p-value">{el?.value ?? "-"}</p>
              </div>
            );
          })}
        </section>

        {/* right section */}
        <section className="orgdetails-left-section-data">
          {organizationDetailsRightSectionData?.map((el, idx) => {
            return (
              <div className="orgdetails-left-div-data-row" key={el?.id ?? idx}>
                <p className="orgDetails-p-label">{el?.label ?? "-"}</p>
                <p className="orgDetails-p-value">{el?.value ?? "-"}</p>
              </div>
            );
          })}
        </section>
      </div>
    </section>
  );
};

//  personal details section
const PersonalDetails = ({
  fName = "",
  setFName,
  sName = "",
  setSName,
  emailId = "",
  setEmailId,
  phone = "",
  country_code = "",
  inputBox,
  inputStyles,
  city = "",
  employeeCode = "",
}) => {
  // row 1
  const personalDetailsRowOne = [
    // first name
    {
      key: "EMail",
      label: "E-Mail",
      component: (
        <FormControl className="user" variant="standard" fullWidth disabled={!inputBox}>
          <InputLabel htmlFor="mail-input" className="user-input-label-settings" shrink>
            E-mail
          </InputLabel>
          <Input
            id="mail-input"
            value={emailId}
            onChange={(e) => setEmailId(e.target.value)}
            disabled={!inputBox}
            sx={inputStyles}
            disableUnderline={!inputBox}
          />
        </FormControl>
      ),
    },
    {
      key: "phoneNumber",
      label: "Phone Number",
      component: (
        <FormControl className="user" variant="standard" fullWidth disabled={!inputBox}>
          <InputLabel htmlFor="phone-input" className="user-input-label-settings" shrink>
            Phone
          </InputLabel>
          <Input
            id="phone-input"
            value={`${country_code !== "-" ? `+${country_code} ` : ""}${phone}`}
            disabled={true}
            sx={inputStyles}
            disableUnderline={!inputBox}
          />
        </FormControl>
      ),
    },
  ];

  // row 2
  const personalDetailsRowTwo = [
    // Email
    {
      key: "City-location",
      label: "City / location",
      component: (
        <FormControl className="user" variant="standard" fullWidth disabled={!inputBox}>
          <InputLabel htmlFor="city-input" className="user-input-label-settings" shrink>
            City / location
          </InputLabel>
          <Input
            id="city-input"
            value={city}
            onChange={(e) => e.target.value}
            disabled={!inputBox}
            sx={inputStyles}
            disableUnderline={!inputBox}
          />
        </FormControl>
      ),
    },

    // Phone Number
    {
      key: "employeeCode",
      label: "Employee code",
      component: (
        <FormControl className="user" variant="standard" fullWidth disabled={!inputBox}>
          <InputLabel htmlFor="employee-code-input" className="user-input-label-settings" shrink>
            Employee code
          </InputLabel>
          <Input
            id="employee-code-input"
            value={`${country_code !== "-" ? `+${country_code} ` : ""}${phone}`}
            disabled={true}
            sx={inputStyles}
            disableUnderline={!inputBox}
          />
        </FormControl>
      ),
    },
  ];
  const personalDetailsRowThree = [
    // Email
    {
      key: "City-location",
      label: "City / location",
      component: (
        <FormControl className="user" variant="standard" fullWidth disabled={!inputBox}>
          <InputLabel htmlFor="mail-input" className="user-input-label-settings" shrink>
            City / location
          </InputLabel>
          <Input
            id="mail-input"
            value={country_code}
            onChange={(e) => setEmailId(e.target.value)}
            disabled={!inputBox}
            sx={inputStyles}
            disableUnderline={!inputBox}
          />
        </FormControl>
      ),
    },

    // Phone Number
    {
      key: "employeeCode",
      label: "Employee code",
      component: (
        <FormControl className="user" variant="standard" fullWidth disabled={!inputBox}>
          <InputLabel htmlFor="employee-code-input" className="user-input-label-settings" shrink>
            Employee code
          </InputLabel>
          <Input
            id="employee-code-input"
            value={`${country_code !== "-" ? `+${country_code} ` : ""}${phone}`}
            disabled={true}
            sx={inputStyles}
            disableUnderline={!inputBox}
          />
        </FormControl>
      ),
    },
  ];
  return (
    <>
      <section className="personal-details-row-1-section">
        {personalDetailsRowOne?.map((el) => {
          return el?.component ?? <></>;
        })}
      </section>

      <section className="personal-details-row-1-section">
        {personalDetailsRowTwo?.map((el) => {
          return el?.component ?? <></>;
        })}
      </section>
      <section className="personal-details-row-1-section">
        {personalDetailsRowThree?.map((el) => {
          return el?.component ?? <></>;
        })}
      </section>
    </>
  );
};

export const Account = () => {
  const showSnackbar = useSnackbar();
  const { color, setColor, city, setCity } = useContext(UserContext);
  const { notificationPreferences, securitySettings } = useContext(UserContext);
  const activeNotificationsCount = Object.values(notificationPreferences || {})?.filter(
    Boolean
  )?.length;
  const totalNotifications = Object.keys(notificationPreferences || {})?.length;
  const activeSecurityCount = Object.values(securitySettings || {})?.filter(Boolean)?.length;
  const style = {
    backgroundColor: color === "dark" ? "#353a50" : "#fff",
    color: color === "dark" ? "white" : "black",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    // boxShadow: 24,
    p: 4,
    borderRadius: 3,
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [otp, setOtp] = useState("");
  const [pin, setPin] = useState("");
  const [cPin, setCPin] = useState("");
  const [timer, setTimer] = useState(30);
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const [inputBox, setInputbox] = useState(false);
  const [ren, setRen] = useState(true);

  const [retailUserDetails, setRetailUserDetails] = useState(() =>
    JSON.parse(localStorage.getItem("retailUserDetails"))
  );
  const location = useLocation();
  useEffect(() => {
    setRetailUserDetails(JSON.parse(localStorage.getItem("retailUserDetails")));
  }, [ren]);
  // useEffect(() => {
  //   retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  // }, [ren]);
  useEffect(() => {
    if (location.state?.updated) {
      setRen((r) => !r);
    }
  }, [location.state]);

  const firstName = retailUserDetails?.firstName ?? "-";
  const lastName = retailUserDetails?.secondName ?? "-";
  const email = retailUserDetails?.email ?? "-";
  const phone = retailUserDetails?.mobileNumber ?? "-";
  const country_code = retailUserDetails?.countryCode ?? "-";
  const profilePic = localStorage.getItem("logoUrl");
  const [fName, setFName] = useState(firstName);
  const [sName, setSName] = useState(lastName);
  const [emailId, setEmailId] = useState(email);

  const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ").filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  };

  const handleEdit = () => {
    setInputbox(true);
    navigate("/profile/edit");
  };

  const handleCancel = () => {
    setInputbox(false);
  };

  const handleSave = () => {
    const payload = {
      uidx: retailUserDetails.uidx,
      mobileNumber: phone,
      email: emailId,
      firstName: fName,
      secondName: sName,
      city: city,
      profilePicture: "",
      tennatId: "",
      roles: retailUserDetails.roles,
      contextPayload: {
        type: "",
        orgId: "",
        contextId: "",
      },
    };

    editUserDetails(payload, retailUserDetails.uidx).then((res) => {
      const updatedUserData = res?.data?.data;
      const finalCity = updatedUserData?.city || city;
      const mergedUserData = { ...retailUserDetails, ...updatedUserData, city: finalCity };
      localStorage.setItem("retailUserDetails", JSON.stringify(mergedUserData));
      setCity(finalCity);
      setRen(!ren);
    });
    setInputbox(false);
  };

  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const orgName = localStorage.getItem("orgName");
  const locName = localStorage.getItem("LocName");
  const branchType = (localStorage.getItem("retailType") || "").toUpperCase();
  const branchSubType = localStorage.getItem("branchSubType");
  const user_name = `${firstName} ${lastName}`.trim();
  // Pre-seed from any cached source so roles show immediately on open
  const [user_roles, setUserRoles] = useState(() => {
    try {
      const cached =
        JSON.parse(localStorage.getItem("user_roles")) ||      // OTP / LocationModal path
        JSON.parse(localStorage.getItem("userRoles")) ||       // Account.js API cache
        retailUserDetails?.roles ||                             // PIN login path
        [];
      return Array.isArray(cached) && cached?.length > 0 ? cached : [];
    } catch {
      return [];
    }
  });
  const sourceApp = localStorage.getItem("sourceApp");

  const fetchingOrganisation = () => {
    const _userDetails = (() => {
      try { return JSON.parse(localStorage.getItem("user_details")) || {}; } catch { return {}; }
    })();
    const _uidx = retailUserDetails?.uidx || _userDetails?.uidx;

    fetchOrganisations()
      .then((orgRes) => {
        const orgIdList = orgRes?.data?.data?.orgIdList?.RETAIL;

        getUserRolesById(_uidx, orgIdList)
          .then((res) => {
            if (res?.data?.status !== "SUCCESS") {
              showSnackbar("failed to fetch user roles", "error");
              return;
            }
            const roles = res?.data?.data?.roles || [];
            setUserRoles(roles);
            localStorage.setItem("userRoles", JSON.stringify(roles));
          })
          .catch((err) => {
            console.error("Error fetching user roles by filter", err);
          });
      })
      .catch((err) => {
        console.error("Error fetching organisations", err);
      });
  };

  useEffect(() => {
    // uidx may come from PIN login (retailUserDetails) or OTP login (user_details)
    const userDetails = (() => {
      try { return JSON.parse(localStorage.getItem("user_details")) || {}; } catch { return {}; }
    })();
    const uidx = retailUserDetails?.uidx || userDetails?.uidx;
    if (uidx) {
      fetchingOrganisation();
    }
  }, [retailUserDetails?.uidx]);

  const [os, setOs] = useState("");
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [browser, setBrowser] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [device, setDevice] = useState("");
  const [pCode, setPCode] = useState("");

  useEffect(() => {
    // OS
    const operatingSystem = navigator.platform;
    setOs(operatingSystem);
    // BROWSER
    const userAgent = window.navigator.userAgent;
    if (userAgent.includes("Chrome")) {
      setBrowser("Google Chrome");
    } else if (userAgent.includes("Firefox")) {
      setBrowser("Mozilla Firefox");
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      setBrowser("Apple Safari");
    } else if (userAgent.includes("Edge")) {
      setBrowser("Microsoft Edge");
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      setBrowser("Opera");
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) {
      setBrowser("Internet Explorer");
    } else {
      setBrowser("Other");
    }
    // DEVICE
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
        navigator.userAgent
      )
    ) {
      setDevice("This device is Mobile");
    } else if (/Windows/i.test(navigator.userAgent)) {
      setDevice("This device is Desktop");
    } else {
      setDevice("This device is tablet");
    }
  }, []);
  useEffect(() => {
    // ADDRESS
    navigator.geolocation.getCurrentPosition(function (position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      setLat(latitude);
      setLong(longitude);
      getLocDetailByLongAndLat(latitude, longitude)
        .then((res) => {
          if (res?.data?.address) {
            const cityRes =
              res?.data?.address?.city || res?.data?.address?.village || res?.data?.address?.town;
            const state = res?.data?.address?.state;
            const country = res?.data?.address?.country;
            const postcode = res?.data?.address?.postcode;
            if (!city) {
              setCity(cityRes);
              const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails")) || {};
              const updatedDetails = { ...retailUserDetails, city: cityRes };
              localStorage.setItem("retailUserDetails", JSON.stringify(updatedDetails));
            }
            setState(state);
            setCountry(country);
            setPCode(postcode);
          } else {
            // Handle error
          }
        })
        .catch((err) => {});
    });
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleResendOtp = () => {
    showSnackbar("OTP sent successfully", "success");
    setTimer(30);
    resetPinFn();
  };

  //logout session api added---
  const [logoutLoader, setlogoutLoader] = useState(false);
  const sessionId = localStorage.getItem("sessionId");
  const handleLogout = () => {
    if (sessionId) {
      showSnackbar("Close session to signout", "error");
      window.dispatchEvent(new Event("pos:open-close-session"));
    } else {
      setlogoutLoader(true);

      const payload = {
        metaData: {
          os: os,
          latitude: lat,
          browser: browser,
          city: city,
          country: country,
          postCode: pCode,
          longitude: long,
          device: device,
        },
      };

      stopNotificationPolling();
      logoutSession(payload)
        .then((res) => {
          showSnackbar("Successfully Logged out", "success");
          setlogoutLoader(true);
          // navigate("/");
          window.location.reload();
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setlogoutLoader(false);
        });
    }
  };

  var userDetails = localStorage.getItem("retailUserDetails");
  var user = JSON.parse(userDetails);

  const sendOtp = useMutation({
    mutationFn: (payload) => resetPin(payload),
    onSuccess: () => {
      showSnackbar("OTP sent successfully", "success");
      handleOpen();
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const resetPinFn = () => {
    const payload = {
      mobile: user.mobileNumber,
    };
    sendOtp.mutate(payload);
  };

  const saveResetPin = () => {
    const updatePayload = {
      mobile: user.mobileNumber,
      primaryPassword: cPin,
      otp: otp,
    };

    if (Number(cPin) === Number(pin)) {
      updatePin(updatePayload)
        .then((response) => {
          showSnackbar("PIN changed successfully", "success");
          handleClose();
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
        });
    } else {
      showSnackbar("PIN doesn't match. Please enter the correct PIN", "error");
    }
  };

  useEffect(() => {
    const payload = {
      uidx: user?.uidx,
    };
    getPosUserRole(payload)
      .then((res) => {
        // setRole(res?.data?.data[0]);
        setRole(res?.data?.data?.join(", "));
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        open ? saveResetPin() : inputBox ? handleSave() : null;
      } else if (e.key === "Escape") {
        open || inputBox ? handleClose() : inputBox ? handleCancel() : null;
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, inputBox]);

  const inputStyles = {
    "& .MuiInput-input.Mui-disabled": {
      fontWeight: 400,
      fontSize: "16px",
      backgroundColor: "transparent",
      WebkitTextFillColor: "#181D28",
    },
    "& .MuiInput-input": {
      backgroundColor: "transparent",
      WebkitTextFillColor: "#717681",
    },
    backgroundColor: "transparent",
    // remove underline in view mode
    "&:before": {
      borderBottom: inputBox ? "1px solid rgba(0,0,0,0.42)" : "none",
    },

    "&:after": {
      borderBottom: inputBox ? "2px solid #1976d2" : "none",
    },

    "&:hover:not(.Mui-disabled):before": {
      borderBottom: inputBox ? "1px solid rgba(0,0,0,0.87)" : "none",
    },
  };

  const handleOTPChange = (e) => {
    const value = e.target.value?.trim();
    if (value?.length > 6) return;

    setOtp(value);
  };

  const handlePinChange = (e) => {
    const value = e.target.value?.trim();
    if (value?.length > 4) return;

    setPin(value);
  };

  const handleCPinChange = (e) => {
    const value = e.target.value?.trim();
    if (value?.length > 4) return;

    setCPin(value);
  };

  const handle = () => {
    navigate("/");
  };

  // Dynamic info items using available data
  const infoItems = [
    {
      // icon: <PosCustomIcon icon={<EnvelopeIcon />} width={"18px"} height={"18px"} color="gray" />,
      icon: <EnvelopeIcon />,
      label: "Email address",
      value: email || "-",
      testId: "text-profile-email",
    },

    {
      // icon: <PosCustomIcon icon={<PhoneIcon />} width={"18px"} height={"18px"} color="gray" />,
      icon: <PhoneIcon />,
      label: "Phone number",
      value: `${country_code !== "-" ? `+${country_code} ` : ""}${phone}` || "-",
      testId: "text-profile-phone",
    },
    {
      // icon: <PosCustomIcon icon={<MapPinIcon />} width={"18px"} height={"18px"} color="gray" />,
      icon: <MapPinIcon />,
      label: "City / location",
      value: city || "-",
      testId: "text-profile-location",
    },
    {
      // icon: <PosCustomIcon icon={<UserIcon />} width={"18px"} height={"18px"} color="gray" />,
      icon: <UserIcon />,
      label: "Employee code",
      value: retailUserDetails?.employeeCode || "-",
      testId: "text-profile-employee-code",
    },
    {
      // icon: <PosCustomIcon icon={<CalendarIcon />} width={"18px"} height={"18px"} color="gray" />,
      icon: <CalendarIcon />,
      label: "Joined on",
      value: retailUserDetails?.createdDate
        ? new Date(retailUserDetails.createdDate).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        : "-",
      testId: "text-profile-joined-on",
    },
    {
      // icon: <PosCustomIcon icon={<ClockIcon />} width={"18px"} height={"18px"} color="gray" />,
      icon: <ClockIcon />,
      label: "Timezone",
      value: Intl.DateTimeFormat().resolvedOptions().timeZone || "GMT +05:30",
      testId: "text-profile-timezone",
    },
  ];

  // const ProfileSection = ({
  //   type,
  //   title,
  //   subtitle,
  //   description,
  //   badgeText,
  //   badgeVariant = "default",
  //   infoItems = [],
  //   statusItems = [],
  //   quickActions = [],
  //   editButton,
  // }) => {
  //   const getTitleClass = () => {
  //     switch (type) {
  //       case "info":
  //         return "info";
  //       case "status":
  //         return "status";
  //       case "security":
  //         return "security";
  //       case "quick-actions":
  //         return "quick-actions";
  //       default:
  //         return "default";
  //     }
  //   };

  //   const getStatusClass = (status) => {
  //     const statusMap = {
  //       Enabled: "status-enabled",
  //       Muted: "status-muted",
  //       On: "status-on",
  //       Off: "status-off",
  //     };
  //     return statusMap[status] || "status-muted";
  //   };

  //   const getBadgeClass = () => {
  //     const badgeMap = {
  //       default: "default",
  //       violet: "violet",
  //       emerald: "emerald",
  //     };
  //     return badgeMap[badgeVariant] || "default";
  //   };

  //   return (
  //     <div className="profile-section">
  //       {/* Header */}
  //       <div className="profile-section-header">
  //         <div>
  //           <p className={`profile-section-title ${getTitleClass()}`}>{title}</p>
  //           <h3 className="profile-section-heading">{subtitle}</h3>
  //           {description && <p className="profile-section-description">{description}</p>}
  //           <p className="profile-section-subtitle">{badgeText?.description || ""}</p>
  //         </div>

  //         {editButton && (
  //           <PosCustomButton
  //             variant="black-s"
  //             title={editButton?.text}
  //             radius="16px"
  //             height="37px"
  //             width="104px"
  //             onClickFunction={(e) => {
  //               if (editButton?.onClick) editButton?.onClick(e);
  //               if (editButton?.href) navigate(editButton?.href);
  //             }}
  //           />
  //         )}
  //         {/* <button
  //             className="edit-button"
  //             data-testid={editButton?.testId}
  //             onClick={(e) => {
  //               if (editButton?.onClick) editButton?.onClick(e);
  //               if (editButton?.href) navigate(editButton?.href);
  //             }}
  //           >
  //             {editButton?.text}
  //           </button> */}

  //         {badgeText && !editButton && (
  //           <div className={`profile-badge ${getBadgeClass()}`} data-testid={badgeText?.testId}>
  //             {badgeText?.text}
  //           </div>
  //         )}
  //       </div>

  //       {/* Info Grid (for type='info') */}
  //       {type === "info" && infoItems?.length > 0 && (
  //         <div className="info-grid">
  //           {infoItems?.map((item, index) => (
  //             <div key={index} className="info-card">
  //               <div className="info-card-content">
  //                 <div className="info-icon">
  //                   <PosCustomIcon icon={item?.icon} width={"18px"} height={"18px"} color="gray" />
  //                   {/* {item?.icon} */}
  //                 </div>
  //                 <div>
  //                   <p className="info-label">{item?.label}</p>
  //                   <p className="info-value" data-testid={item?.testId}>
  //                     {item?.value}
  //                   </p>
  //                 </div>
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       )}

  //       {/* Status List (for type='status' or 'security') */}
  //       {(type === "status" || type === "security") && statusItems?.length > 0 && (
  //         <div className="status-list">
  //           {statusItems?.map((item, index) => (
  //             <div key={index} className="status-card">
  //               <div className="status-card-content">
  //                 <div>
  //                   <p className="status-title">{item?.title}</p>
  //                   <p className="status-description">{item?.description}</p>
  //                 </div>
  //                 <span
  //                   className={`rounded-full px-3 py-1 text-xs font-semibold ${getStatusClass(
  //                     item?.status
  //                   )}`}
  //                   data-testid={item?.testId}
  //                 >
  //                   {item?.status}
  //                 </span>
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       )}

  //       {/* Quick Actions (for type='quick-actions') */}
  //       {type === "quick-actions" && quickActions?.length > 0 && (
  //         <div className="quick-actions-list">
  //           {quickActions?.map((action, index) => (
  //             <div key={index} className="quick-action-card">
  //               <div className="quick-action-left">
  //                 <div className="quick-action-icon">
  //                   <PosCustomIcon
  //                     icon={action?.icon}
  //                     height={"18px"}
  //                     width={"18px"}
  //                     color="gray"
  //                   />
  //                 </div>
  //                 <div>
  //                   <p className="quick-action-title">{action?.title}</p>
  //                   <p className="quick-action-description">{action?.description}</p>
  //                 </div>
  //               </div>
  //               {/* <PosCustomButton
  //                 title=""
  //                 iconOnLeft={
  //                   <PosCustomIcon icon={<ChevronRightIcon />} height={"26px"} width={"26px"} />
  //                 }
  //                 onClickFunction={(e) => {
  //                   if (action?.onClick) action.onClick(e);
  //                   if (action?.href) navigate(action?.href);
  //                 }}
  //                 variant="profile-back"
  //                 radius="9999px"
  //                 p="8px"
  //               /> */}
  //               <PosCustomIcon
  //                 icon={<ChevronRightIcon />}
  //                 height={"26px"}
  //                 width={"26px"}
  //                 onClickFunction={(e) => {
  //                   if (action?.onClick) action.onClick(e);
  //                   if (action?.href) navigate(action?.href);
  //                 }}
  //                 pointer={true}
  //               />
  //               {/* <button
  //                 className="chevron-button"
  //                 data-testid={action?.buttonTestId}
  //                 onClick={(e) => {
  //                   if (action?.onClick) action.onClick(e);
  //                   if (action?.href) navigate(action?.href);
  //                 }}
  //               >
  //                 <svg
  //                   xmlns="http://www.w3.org/2000/svg"
  //                   width="20"
  //                   height="20"
  //                   viewBox="0 0 24 24"
  //                   fill="none"
  //                   stroke="currentColor"
  //                   strokeWidth="2"
  //                   strokeLinecap="round"
  //                   strokeLinejoin="round"
  //                 >
  //                   <path d="m9 18 6-6-6-6" />
  //                 </svg>
  //               </button> */}
  //             </div>
  //           ))}
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const ProfileSection = ({
    type,
    title,
    subtitle,
    description,
    badgeText,
    badgeVariant = "default",
    infoItems = [],
    statusItems = [],
    quickActions = [],
    notificationItems = [],
    notificationSummary = null,
    editButton,
    subtitleIcon,
  }) => {
    const getTitleClass = () => {
      switch (type) {
        case "info":
          return "info";
        case "status":
          return "status";
        case "security":
          return "security";
        case "quick-actions":
          return "quick-actions";
        case "notifications":
          return "notifications";
        default:
          return "default";
      }
    };

    const getStatusClass = (status) => {
      const statusMap = {
        Enabled: "status-enabled",
        Muted: "status-muted",
        On: "status-on",
        Off: "status-off",
      };
      return statusMap[status] || "status-muted";
    };

    const getBadgeClass = () => {
      const badgeMap = {
        default: "default",
        violet: "violet",
        emerald: "emerald",
      };
      return badgeMap[badgeVariant] || "default";
    };

    return (
      <div className="profile-section">
        {/* Header */}
        <div className="profile-section-header">
          <div>
            <p className={`profile-section-title ${getTitleClass()}`}>{title}</p>
            <h3 className="profile-section-heading">
              {subtitleIcon && (
                <span className="subtitle-icon-span">
                  {subtitleIcon && <PosCustomIcon icon={subtitleIcon} color="gray" />}
                </span>
              )}

              {subtitle}
            </h3>
            {description && (
              <p
                className="profile-section-description"
                style={{ paddingLeft: subtitleIcon ? "57px" : "0px" }}
              >
                {description}
              </p>
            )}
            <p className="profile-section-subtitle">{badgeText?.description || ""}</p>
          </div>

          {editButton && (
            <PosCustomButton
              variant="black-s"
              title={editButton?.text}
              radius="16px"
              height="37px"
              width="104px"
              onClickFunction={(e) => {
                if (editButton?.onClick) editButton?.onClick(e);
                if (editButton?.href) navigate(editButton?.href);
              }}
            />
          )}

          {badgeText && !editButton && (
            <div className={`profile-badge ${getBadgeClass()}`} data-testid={badgeText?.testId}>
              {badgeText?.text}
            </div>
          )}
        </div>

        {/* Info Grid (for type='info') */}
        {type === "info" && infoItems?.length > 0 && (
          <div className="info-grid">
            {infoItems?.map((item, index) => (
              <div key={index} className="info-card">
                <div className="info-card-content">
                  <div className="info-icon">
                    <PosCustomIcon icon={item?.icon} width={"18px"} height={"18px"} color="gray" />
                  </div>
                  <div>
                    <p className="info-label">{item?.label}</p>
                    <p className="info-value" data-testid={item?.testId}>
                      {item?.value}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Status List (for type='status' or 'security') */}
        {(type === "status" || type === "security") && statusItems?.length > 0 && (
          <div className="status-list">
            {statusItems?.map((item, index) => (
              <div key={index} className="status-card">
                <div className="status-card-content">
                  <div>
                    <p className="status-title">{item?.title}</p>
                    <p className="status-description">{item?.description}</p>
                  </div>
                  <span
                    className={`rounded-full px-3 py-1 text-xs font-semibold ${getStatusClass(
                      item?.status
                    )}`}
                    data-testid={item?.testId}
                  >
                    {item?.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Notification Preferences (for type='notifications') */}
        {type === "notifications" && (
          <div className="notifications-container">
            {notificationSummary && (
              <div className="notification-summary">
                <p className="notification-summary-text" data-testid="notification-summary-count">
                  {notificationSummary}
                </p>
              </div>
            )}
            <div className="notifications-grid">
              {notificationItems?.map((item, index) => (
                <div
                  key={index}
                  className="notification-row"
                  data-testid={item?.testId}
                  onClick={(e) => {
                    e.preventDefault();
                    showSnackbar("Feature is coming soon", "info");
                  }}
                >
                  <label
                    htmlFor={item?.id}
                    className="notification-label"
                    data-testid={item?.labelTestId}
                  >
                    {item?.label}
                  </label>
                  <Switch
                    id={item?.id}
                    checked={item?.enabled}
                    onChange={(newValue) => item?.onToggle?.(item?.id, newValue)}
                    disabled={item?.disabled}
                    aria-label={item?.label}
                    data-testid={item?.statusTestId}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Quick Actions (for type='quick-actions') */}
        {type === "quick-actions" && quickActions?.length > 0 && (
          <div className="quick-actions-list">
            {quickActions?.map((action, index) => (
              <div key={index} className="quick-action-card">
                <div className="quick-action-left">
                  <div className="quick-action-icon">
                    <PosCustomIcon
                      icon={action?.icon}
                      height={"18px"}
                      width={"18px"}
                      color="gray"
                    />
                  </div>
                  <div>
                    <p className="quick-action-title">{action?.title}</p>
                    <p className="quick-action-description">{action?.description}</p>
                  </div>
                </div>
                <PosCustomIcon
                  icon={<ChevronRightIcon />}
                  height={"26px"}
                  width={"26px"}
                  onClickFunction={(e) => {
                    if (action?.onClick) action.onClick(e);
                    if (action?.href) navigate(action?.href);
                  }}
                  pointer={true}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };
  // const notificationItems = [
  //   {
  //     title: "Critical system alerts",
  //     description: "Instant updates for payment failures, outage alerts, and printer issues.",
  //     status: notificationPreferences?.dineInOrders ? "Enabled" : "Disabled",
  //     testId: "status-notification-critical-alerts",
  //   },
  //   {
  //     title: "Support ticket updates",
  //     description: "Progress notifications when tickets are assigned, updated, or resolved.",
  //     status: notificationPreferences?.scheduledOrders ? "Enabled" : "Disabled",
  //     testId: "status-notification-ticket-updates",
  //   },
  //   {
  //     title: "Inventory exception alerts",
  //     description: "Warnings when sales are blocked because sellable stock is missing.",
  //     status: notificationPreferences?.takeawayOrders ? "Enabled" : "Disabled",
  //     testId: "status-notification-inventory-blocks",
  //   },
  //   {
  //     title: "Shift summary digest",
  //     description: "End-of-shift summary with sales, refunds, discounts, and outlet notes.",
  //     status: notificationPreferences?.deliveryOrders ? "Enabled" : "Muted",
  //     testId: "status-notification-shift-summary",
  //   },
  // ];

  // Security items
  // const securityItems = [
  //   {
  //     title: "Two-factor authentication",
  //     description: "Require OTP verification when signing in from a new device.",
  //     status: securitySettings?.twoFactor ? "On" : "Off",
  //     testId: "status-security-two-factor",
  //   },
  //   {
  //     title: "Login alerts",
  //     description: "Send alerts whenever the account is used on a new device.",
  //     status: securitySettings?.loginAlerts ? "On" : "Off",
  //     testId: "status-security-login-alerts",
  //   },
  //   {
  //     title: "Approval check for sensitive actions",
  //     description: "Require re-authentication before refunds, voids, and inventory overrides.",
  //     status: securitySettings?.sensitiveActions ? "On" : "Off",
  //     testId: "status-security-sensitive-actions",
  //   },
  // ];

  // Quick actions
  const quickActions = [
    {
      // icon: <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect><path d="M12 18h.01"></path></svg>,
      icon: (
        // <PosCustomIcon icon={<DeviceTabletIcon />} height={"18px"} width={"18px"} color="gray" />
        <DeviceTabletIcon />
      ),
      title: "Trusted devices",
      description: "3 active sessions across tablet, terminal, and manager mobile.",
      buttonTestId: "button-profile-trusted-devices",
      href: "/devices",
    },
    {
      // icon: <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M10.268 21a2 2 0 0 0 3.464 0"></path><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"></path></svg>,
      icon: <BellIcon />,

      title: "Notification channels",
      description: "Push, email, and shift-digest preferences are configured here.",
      buttonTestId: "button-profile-notification-details",
      href: "/profile/edit",
    },
  ];
  return (
    <Navbar>
      <Box className="profile-container" m={0} p={0}>
        <div className="profile-container-section">
          <section className="profile-headder-section">
            <div className="profile-header-section-left-div">
              {/* <button class="button-profile-back" onClick={handle}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="m12 19-7-7 7-7"></path>
                  <path d="M19 12H5"></path>
                </svg>
              </button> */}
              <div className="button-profile-back">
                {/* <PosCustomButton
                  iconOnRight={
                    <PosCustomIcon icon={<ArrowLeftIcon />} height="26px" width="26px" />
                  }
                  onClickFunction={handle}
                  height="35px"
                  width="35px"
                  radius="9999px"
                  variant="profile-back"
                /> */}
                <PosCustomIcon
                  icon={<ArrowLeftIcon />}
                  height="16px"
                  width="16px"
                  pointer={true}
                  onClickFunction={handle}
                />
              </div>
              <div>
                <p className="profile-header-section-profile">Profile</p>
                {/* <p className="profile-header-section-sub-profile">
                  View operator details, preferences, and account protection.
                </p> */}
              </div>
            </div>

            {!inputBox && (
              <div className="profile-header-section-right-div">
                <PosCustomButton
                  variant="primary-rounded"
                  radius="15px"
                  p="8px 8px"
                  width="120px"
                  height="38px"
                  title={"Edit Profile"}
                  onClickFunction={handleEdit}
                />
                <PosCustomButton
                  variant="danger-soft"
                  radius="15px"
                  p="8px 8px"
                  width="120px"
                  height="38px"
                  title={"Log Out"}
                  iconOnLeft={
                    <PosCustomIcon
                      icon={<LuLogOut color="#C70036" />}
                      height={"16px"}
                      width={"16px"}
                      color={color === "dark" ? "#FFF" : "#281818"}
                    />
                  }
                  onClickFunction={handleLogout}
                />
                {/* <StyledButton
                  onClick={handleEdit}
                  className="edit-text-icon-1 edit-btn-gap-padding"
                  tabIndex={2}
                >
                  <p className="edit-section-p">Edit</p>
                  <p>
                    <BorderColorOutlinedIcon style={{ width: "16px", height: "16px" }} />
                  </p>
                </StyledButton> */}
              </div>
            )}

            {inputBox && (
              <div className="save-edit-btn-component">
                <PosCustomButton
                  variant="black-s"
                  radius="6px"
                  p="8px 8px"
                  title={"Cancel"}
                  iconOnRight={
                    <PosCustomIcon icon={<XMarkIcon />} height={"16px"} width={"16px"} />
                  }
                  onClickFunction={handleCancel}
                />

                <PosCustomButton
                  variant="blue-d"
                  radius="6px"
                  p="8px 8px"
                  title={"Save Changes"}
                  iconOnRight={
                    <PosCustomIcon
                      icon={<CheckIcon />}
                      height={"16px"}
                      width={"16px"}
                      color="#FFF"
                    />
                  }
                  onClickFunction={handleSave}
                />
              </div>
            )}
          </section>

          <section className="profile-body-section">
            {/* this is the profile section */}
            <ContainerWrapper requiredHeader={false} wrapperRequired={false}>
              <section className="personal-info-container-section">
                <div className="flex">
                  <Box className="avatar-wrapper">
                    <Box className="avatar">{getInitials(user_name)}</Box>
                    <Box className="status-dot" />
                  </Box>

                  <div className="personal-info-details-div">
                    <div className="personal-details-div-wrapper">
                      <p className="personal-details-sub-tab">Profile Details</p>
                      <h2 className="personal-details-h2-tag">{user_name}</h2>
                      <p className="personal-details-sub-tab">
                        {user_roles?.length} assigned roles · {locName} · {city}{" "}
                      </p>
                    </div>
                    <div className="badge-group">
                      <span class="badge">
                        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="icon">
                          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                        </svg> */}
                        <PosCustomIcon
                          icon={<ShieldCheckIcon />}
                          height={"18px"}
                          width={"18px"}
                          color="white"
                        />
                        Admin Access
                      </span>
                      <span class="badge-active">Active</span>
                    </div>
                  </div>
                  <div className="personal-details-cards-container">
                    <Cards header="CLOCKED IN" description="Today" value="N/A" />
                    <Cards header="SHIFT" description="Scheduled coverage" value="N/A" />
                    <div className="personal-details-cards personal-details-cards-small">
                      <p className="personal-details-cards-header">ORGANIZATION</p>
                      <p className="personal-details-cards-value value-margin-bottom">
                        {`${orgName || "N/A"} (${orgId || "N/A"})`}
                      </p>
                      <p className="personal-details-cards-header">LOCATION</p>
                      <p className="personal-details-cards-value">
                        {`${locName || "N/A"} (${locId || "N/A"})`}
                      </p>
                    </div>
                  </div>
                </div>
                <Cards
                  header={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ textTransform: "uppercase" }}>Assigned roles</span>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#fff",
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          padding: "4px 12px",
                          borderRadius: "16px",
                          fontWeight: "500",
                        }}
                      >
                        {user_roles?.length || 0} total
                      </span>
                    </div>
                  }
                  value="Compact access labels keep up to 10-15 responsibilities readable without crowding the header."
                  description={user_roles?.map((ele, ind) => {
                    const formattedRole = ele
                      ?.replaceAll("_", " ")
                      ?.toLowerCase()
                      ?.replace(/\b\w/g, (c) => c.toUpperCase());
                    return (
                      <span
                        className="badge"
                        key={ind}
                        style={{ marginLeft: ind === 0 ? "0px" : "10px" }}
                      >
                        {formattedRole}
                      </span>
                    );
                  })}
                ></Cards>
              </section>
            </ContainerWrapper>

            {/* this is the role tab */}
            {/* <ContainerWrapper
              containerHeadderIcon={
                <PosCustomIcon
                  icon={<FlagIcon />}
                  height={20}
                  width={20}
                  color={color === "dark" ? "#FFF" : "#181D28"}
                />
              }
              containerHeadderTitle="Designation"
            >
              <div className="roles-badge-wrapper">
                {user_roles?.map((role, index) => {
                  const formattedRole = role
                    .replaceAll("_", " ")
                    .toLowerCase()
                    .replace(/\b\w/g, (c) => c.toUpperCase());

                  return (
                    <span key={index} className="role-badge">
                      {formattedRole}
                    </span>
                  );
                })}
              </div>
            </ContainerWrapper> */}
            <div className="layout-grid account-page-content">
              {/* this is the basic info side */}
              <div>
                <ProfileSection
                  type="info"
                  title="Personal information"
                  subtitle="Account and outlet details"
                  description="This page is now the clean read-only overview. All edits happen in a separate dedicated flow."
                  infoItems={infoItems}
                  editButton={{
                    text: "Edit details",
                    href: "/profile/edit",
                    testId: "button-profile-details-edit",
                  }}
                />
                {/* <ProfileSection
                  type="status"
                  title="Notification preferences"
                  subtitle=""
                  description="Review which updates are active. Use the edit flow if you want to change preferences."
                  badgeText={{
                    text: `${activeNotificationsCount} of ${totalNotifications} enabled`,
                    testId: "text-profile-notification-summary-count",
                  }}
                  badgeVariant="violet"
                  statusItems={notificationItems}
                /> */}
                <ProfileSection
                  type="notifications"
                  title=""
                  subtitle="Notification Preferences"
                  subtitleIcon={
                    <PosCustomIcon icon={<BellIcon />} width="24px" height="24px" color="gray" />
                  }
                  description={`${activeNotificationsCount} of ${totalNotifications} alerts enabled`}
                  notificationSummary=""
                  notificationItems={[
                    {
                      id: "switch-dine-in-orders",
                      label: branchType === "GROCERY" ? "In-Store Orders" : "Dine-in Orders",
                      enabled: notificationPreferences?.dineInOrders,
                      disabled: true,
                      testId: "row-notification-dine-in-orders",
                      labelTestId: "text-notification-dine-in-orders",
                      statusTestId: "status-notification-dine-in-orders",
                    },
                    {
                      id: "switch-scheduled-orders",
                      label: "Scheduled Orders",
                      enabled: notificationPreferences?.scheduledOrders,
                      disabled: true,
                      testId: "row-notification-scheduled-orders",
                      labelTestId: "text-notification-scheduled-orders",
                      statusTestId: "status-notification-scheduled-orders",
                    },
                    {
                      id: "switch-takeaway-orders",
                      label: branchType === "GROCERY" ? "Pick-Up Orders" : "Takeaway Orders",
                      enabled: notificationPreferences?.takeawayOrders,
                      disabled: true,
                      testId: "row-notification-takeaway-orders",
                      labelTestId: "text-notification-takeaway-orders",
                      statusTestId: "status-notification-takeaway-orders",
                    },
                    {
                      id: "switch-delivery-orders",
                      label: "Delivery Orders",
                      enabled: notificationPreferences?.deliveryOrders,
                      disabled: true,
                      testId: "row-notification-delivery-orders",
                      labelTestId: "text-notification-delivery-orders",
                      statusTestId: "status-notification-delivery-orders",
                    },
                    {
                      id: "switch-online-orders",
                      label: "Online Orders",
                      enabled: notificationPreferences?.onlineOrders,
                      disabled: true,
                      testId: "row-notification-online-orders",
                      labelTestId: "text-notification-online-orders",
                      statusTestId: "status-notification-online-orders",
                    },
                  ]}
                />
              </div>
              {/* <div> */}
              {/* <ProfileSection
                  type="security"
                  title="Security settings"
                  subtitle="Protection overview"
                  description="Review login protection, trusted device coverage, and approval checks for risky actions."
                  badgeText={{
                    text: `${activeSecurityCount} safeguards active`,
                    testId: "text-profile-security-summary-count",
                  }}
                  badgeVariant="emerald"
                  statusItems={securityItems}
                /> */}

              {/* <ProfileSection
                  type="quick-actions"
                  title="Quick actions"
                  subtitle=""
                  // description="Commonly used actions and shortcuts for efficient account management."
                  badgeText={null}
                  quickActions={quickActions}
                /> */}
              {/* </div> */}

              {/* notofications Preferences */}
              {/* <ContainerWrapper
              containerHeadderIcon={
                <PosCustomIcon icon={<BellAlertIcon />} height={20} width={20} color={color === "dark" ? "#FFF" : "#181D28"} />
              }
              containerHeadderTitle="Notification Preferences"
            >
              <section className="notification-preference-section">
                <div className="notification-preference-left-div">
                  <div className="toggle-container-div">
                    <p className="toggleButton-p">
                      <CustomToggleButton />
                    </p>

                    <p className="toggleButton-label">Dine-in Orders</p>
                  </div>
                  <div className="toggle-container-div">
                    <p className="toggleButton-p">
                      <CustomToggleButton />
                    </p>

                    <p className="toggleButton-label">Takeaway Orders</p>
                  </div>
                  <div className="toggle-container-div">
                    <p className="toggleButton-p">
                      <CustomToggleButton />
                    </p>

                    <p className="toggleButton-label">Delivery Orders</p>
                  </div>
                  <div className="toggle-container-div">
                    <p className="toggleButton-p">
                      <CustomToggleButton />
                    </p>

                    <p className="toggleButton-label">Online Orders</p>
                  </div>
                </div>

                <div className="notification-preference-right-div">
                  <div className="toggle-container-div">
                    <p className="toggleButton-p">
                      <CustomToggleButton />
                    </p>

                    <p className="toggleButton-label">Scheduled Orders</p>
                  </div>
                </div>
              </section>
            </ContainerWrapper> */}

              {/* organization information */}
            </div>

            {/* set new PIN */}
          </section>
        </div>

        {/* this is the modal  */}
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="pin-wrapper-modal-box"
        >
          <Box
            sx={{
              "&:focus": {
                outline: "none",
              },
              ...style,
            }}
          >
            <Box className="change-pin-wrapper-box">
              <p className="old-pin-text">Otp: </p>
              <input
                value={otp}
                onChange={handleOTPChange}
                type="number"
                className="change-pin-otp-input"
              />
              {/* <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span>&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle="otp_input_box"
                  inputType="number"
                /> */}
            </Box>
            <Box className="change-pin-wrapper-box">
              <p className="old-pin-text">New Pin: </p>
              <input
                value={pin}
                onChange={handlePinChange}
                type="number"
                className="change-pin-otp-input"
              />
              {/* <OtpInput
                  value={pin}
                  onChange={setPin}
                  numInputs={4}
                  renderSeparator={<span>&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle="otp_input_box"
                  inputType="number"
                /> */}
            </Box>
            <Box className="change-pin-wrapper-box">
              <p className="old-pin-text">Confirm Pin: </p>
              <input
                value={cPin}
                onChange={handleCPinChange}
                type="number"
                className="change-pin-otp-input"
              />
              {/* <OtpInput
                  value={cPin}
                  onChange={setCPin}
                  numInputs={4}
                  renderSeparator={<span>&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle="otp_input_box"
                  inputType="number"
                /> */}
            </Box>
            <Box className="resend-otp-wrapper-box">
              <p
                onClick={timer === 0 ? handleResendOtp : null}
                style={{
                  cursor: timer === 0 ? "pointer" : "not-allowed",
                  color: timer === 0 ? "blue" : "grey",
                }}
              >
                Resend OTP {timer > 0 && `(${timer}s)`}
              </p>
            </Box>
            <Box className="save-wrapper-box-forgot">
              <StyledButton color="red" variant="secondary" onClick={handleClose}>
                Cancel
              </StyledButton>
              <StyledButton
                onClick={saveResetPin}
                disabled={cPin.length !== 4 || pin.length !== 4 || otp.length !== 6}
              >
                Save
              </StyledButton>
            </Box>
          </Box>
        </Modal>
      </Box>
    </Navbar>
  );
};
